<template>

  <div id="activate-dialog" class="ui tiny modal activate-modal">

    <div class="ui header">
      Ativação de Orçamento Cancelado
    </div>

    <div class="content">

      <p>Confirma a ativação do Orçamento <strong>{{ quotation ? quotation.id : '' }}</strong> cancelado ?</p>

      <div class="ui orange message">
        <i class="exclamation circle icon"></i> Essa operação volta o orçamento cancelado para o status em manutenção.
      </div> 

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Não
      </button>
      <button type="button" class="ui basic red button"  @click="onActivateConfirm()">
        <i class="check icon"></i>
        Sim
      </button>      
    </div>

  </div>

</template>

<script>

  export default {

    props: ["quotation"],  

    beforeDestroy() {
      $(".activate-modal").remove()
    },
    
    methods: {

      show() {
        $("#activate-dialog").modal("show")        
      },

      hide() {
        $("#activate-dialog").modal("hide")
      },

      async onActivateConfirm() {

        this.$emit("onActivateConfirm")

        this.hide()
      },
    },
  }

</script>

